import { TokenCredentials } from './token-credentials';

export class Stock {
    credentials: TokenCredentials;
    id : number;
	userid : number;
    
    binid : number;
    binLocation: string;

    articleid: number;
    articleNumber: string;
    articleDescr1: string;
    articleDescr2: string;
    articleBaseUnit: string;

    quantity: number;
    quantityReserved: number;
    reservationCode: string;
    
    receiptId: number;
    receiptPosId: number;

    created : Date;
    updated : Date;
}

export class InventoryResult {
    credentials: TokenCredentials;

    binId : number;
    stocks : InventoryStockResult[];
}

export class InventoryStockResult {
    articleId : number;
    quantity : number;
}


// WEBPACK FOOTER //
// ./src/providers/dto/stock.ts